import { Typography } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';

import { Position } from '@work4all/models/lib/Classes/Position.entity';

import { UserIconCell } from '../../../../../../../../../../../components/data-tables/cell-renderer/userIconCell';
import {
  Checked,
  Unchecked,
} from '../../../../../../../../../../../components/data-tables/grid/cells/CheckBoxGridCell';
import {
  PositionDoneFormData,
  usePositionDoneWithData,
} from '../../../../../../../../../../../hooks/use-position-done';
import { OnEditPosition } from '../../edit-table/types';

type Props = {
  position: Position;
  contractId?: string | number;
  onEditPosition: (result: OnEditPosition<Position>) => void;
};

export const PositionDoneCheckbox = ({
  position,
  contractId,
  onEditPosition,
}: Props) => {
  const onPositionDone = useCallback(
    (formData: PositionDoneFormData) => {
      if (formData.toRemoveDone) {
        onEditPosition({
          position: {
            id: formData.position.id,
            isFinished: false,
            finishedDate: null,
            finishedByUserId: null,
            finishedNote: null,
          },
        });
      } else {
        onEditPosition({
          position: {
            id: formData.position.id,
            isFinished: true,
            finishedDate: formData.completionDate,
            finishedByUserId: formData.user?.id,
            finishedNote: formData.notes,
          },
        });
      }
    },
    [onEditPosition]
  );

  const { actions } = usePositionDoneWithData({
    contractId,
    overrides: useMemo(
      () => ({
        user: position.responsibleUser,
        position,
      }),
      [position]
    ),
    onPositionDone,
  });

  const handleToggle = () => {
    actions[0].handler(position.id);
  };

  if (position.isFinished) {
    return (
      <Tooltip title={position.finishedNote}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: '-4px',
            cursor: 'pointer',
          }}
          onClick={handleToggle}
        >
          {Checked}
          {position.finishedDate && (
            <Typography variant="body2">
              {new Date(position.finishedDate).toLocaleDateString()}
            </Typography>
          )}
          {position.finishedByUserId && (
            <UserIconCell
              value={position.finishedByUserId}
              column={{
                accessor: () => position.finishedByUserId,
                cellParams: { locked: false },
              }}
              row={{ original: position }}
            />
          )}
        </div>
      </Tooltip>
    );
  }

  return (
    <div
      style={{ marginTop: '-2px', cursor: 'pointer' }}
      onClick={handleToggle}
    >
      {Unchecked}
    </div>
  );
};
